import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../_virtual/_rollupPluginBabelHelpers.js';
import deepmerge from 'deepmerge';
var loadData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(endpoint, options) {
    var normalize,
      rethrow,
      defaultOptions,
      response,
      error,
      json,
      _json$data,
      data,
      normalizeObject,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          normalize = _args.length > 2 && _args[2] !== undefined ? _args[2] : true;
          rethrow = _args.length > 3 && _args[3] !== undefined ? _args[3] : true;
          defaultOptions = {
            method: 'GET',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'Cache-Control': 'no-cache'
            },
            credentials: 'include'
          };
          options = deepmerge(defaultOptions, options);
          _context.prev = 4;
          _context.next = 7;
          return fetch(endpoint, options);
        case 7:
          response = _context.sent;
          _context.next = 13;
          break;
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](4);
          throw new Error('Request was cancelled.');
        case 13:
          if (!(rethrow && response.status >= 400)) {
            _context.next = 17;
            break;
          }
          error = new Error("".concat(response.status, ": ").concat(response.statusText, " received from ").concat(endpoint));
          error.response = response;
          throw error;
        case 17:
          if (!(response.status === 204)) {
            _context.next = 19;
            break;
          }
          return _context.abrupt("return", response);
        case 19:
          _context.prev = 19;
          _context.next = 22;
          return response.json();
        case 22:
          json = _context.sent;
          if (!normalize) {
            _context.next = 27;
            break;
          }
          data = (_json$data = json.data) !== null && _json$data !== void 0 ? _json$data : json;
          normalizeObject = function normalizeObject(val) {
            return Object.assign({
              id: val.id,
              type: val.type
            }, val.attributes);
          };
          return _context.abrupt("return", Array.isArray(data) ? data.map(normalizeObject) : normalizeObject(data));
        case 27:
          return _context.abrupt("return", json);
        case 30:
          _context.prev = 30;
          _context.t1 = _context["catch"](19);
          throw {
            response: response
          };
        case 33:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[4, 10], [19, 30]]);
  }));
  return function loadData(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var loadApiData = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(endpoint, normalize) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return requestApiData(endpoint, normalize);
        case 2:
          return _context2.abrupt("return", _context2.sent);
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function loadApiData(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
var loadExternalData = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(endpoint, authToken, normalize) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return requestExternalData(endpoint, authToken, normalize);
        case 2:
          return _context3.abrupt("return", _context3.sent);
        case 3:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function loadExternalData(_x5, _x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();
var requestApiData = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(endpoint, normalize) {
    var method,
      options,
      rethrow,
      tokenMeta,
      csrfToken,
      defaultOptions,
      _args4 = arguments;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          method = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : 'GET';
          options = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : {};
          rethrow = _args4.length > 4 && _args4[4] !== undefined ? _args4[4] : true;
          tokenMeta = document.querySelector('meta[name=csrf-token]');
          csrfToken = tokenMeta ? tokenMeta.attributes.content.value : '';
          defaultOptions = {
            method: method,
            headers: {
              'X-CSRF-Token': csrfToken
            },
            credentials: 'include'
          };
          options = deepmerge(defaultOptions, options);
          _context4.next = 9;
          return loadData(endpoint, options, normalize, rethrow);
        case 9:
          return _context4.abrupt("return", _context4.sent);
        case 10:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function requestApiData(_x8, _x9) {
    return _ref4.apply(this, arguments);
  };
}();
var requestExternalData = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(endpoint, authToken, normalize) {
    var method,
      options,
      rethrow,
      defaultOptions,
      _args5 = arguments;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          method = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : 'GET';
          options = _args5.length > 4 && _args5[4] !== undefined ? _args5[4] : {};
          rethrow = _args5.length > 5 && _args5[5] !== undefined ? _args5[5] : true;
          defaultOptions = {
            method: method,
            headers: {
              Authorization: "Bearer ".concat(authToken)
            }
          };
          options = deepmerge(defaultOptions, options);
          _context5.next = 7;
          return loadData(endpoint, options, normalize, rethrow);
        case 7:
          return _context5.abrupt("return", _context5.sent);
        case 8:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function requestExternalData(_x10, _x11, _x12) {
    return _ref5.apply(this, arguments);
  };
}();
export { loadApiData, loadData, loadExternalData, requestApiData, requestExternalData };